/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { overrideForwardRef } from "../OverridableComponent";

import "./List.scss";

export interface IListProps {
	children?: React.ReactNode;
	className?: string;
}

export const List = overrideForwardRef<IListProps, "ul">(
	({ children, className, Component, ...props }, ref) => {
		const baseClass = BEM("edt-list");

		if (className) {
			baseClass.add(className);
		}

		return (
			<Component className={baseClass.toClassName()} ref={ref} {...props}>
				{children}
			</Component>
		);
	}
);

List.defaultProps = {
	Component: "ul"
};
